import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import React from 'react'

const DisplayNameWithFirmNameCell = ({ value }: { value: string }) => {
    if (value) {
        const actualString = value
            ?.split('%|%')
            ?.map((val) => val?.replace(/\'/g, ''))
        const formattedString =
            actualString?.[0] !== 'null'
                ? `${actualString?.[0]} (${actualString?.[1]})`
                : `${actualString?.[1]}`

        return (
            <TooltipEllipsis text={formattedString ?? ''}>
                <Typography
                    style={{
                        fontSize: pxToRem(14),
                        fontFamily: 'Roboto',
                    }}
                    noWrap
                >
                    {formattedString}
                </Typography>
            </TooltipEllipsis>
        )
    }
    return <></>
}

export default DisplayNameWithFirmNameCell
